import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApDynComponentComponent}                                from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {combineLatest, Observable, Subscription}                from 'rxjs';
import {
  ApDynGridPagerConfigBase
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {PagerBuilder}                                           from './configs/pager-builder';
import {FormStore}                                              from '../../stores/layout/form.store';
import {
  NFertilizationStore
}                                                               from '../../stores/n-fertilization/n-fertilization.store';
import {CampaignYearStore}                                      from '../../stores/login/campaignyear.store';
import {filter, first, map, skip}                               from 'rxjs/operators';
import {FieldStore}                                             from '../../stores/farm/field.store';
import {CropTypeStore}                                          from '../../stores/base-data/crop.types.store';
import {
  NFertilizationPlansGridBuilderService
}                                                               from './configs/n-fertilization-plans-grid-builder.service';
import {
  ApNFertilizationBookingComponent
}                                                               from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-booking.component';
import {ApUtilService}                                          from '../../ap-utils/service/ap-util.service';
import {FertilizerStore}                                        from '../../stores/base-data/fertilizer.store';
import {
  ApNFertilizationEditComponent
}                                                               from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-edit.component';
import {ModalDialogStore}                                       from '../../stores/dialog/modal.dialog.store';
import {ModalDialogPresets}                                     from '../../stores/dialog/modal.dialog.presets';
import {RouterStore}                                            from '../../stores/router/router.store';
import {
  CropApplicationStore
}                                                               from '../../stores/task-management/crop-application.store';
import {MapStore}                                               from '../../stores/map/map.store';
import {ApNFertilizationCommonService}                          from '../services/ap-n-fertilization.common.service';
import {
  ApTooltipContentService
}                                                               from '../../ap-utils/service/ap-tooltip-content.service';
import {TaskManagementAction}                                   from '../../task-management/task-management.types';
import {
  ApNFertilizationShowComponent
}                                                               from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-show.component';
import {FertilizerService}                                      from '../../services/data/fertilizer.service';
import {
  DropDownButtonData
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {NFertilizationService}                                  from '../../services/data/n-fertilization.service';
import {StatisticStore}                                         from '../../stores/statistic/statistic.store';
import {ApNFertilizationComponentService}                       from '../services/ap-n-fertilization-component.service';
import {ISummaryWithPlanBooks}                                  from '../types/n-fertilization-common.types';
import {ObjectFactory}                                          from 'ts-tooling';
import {
  PlanningEntryComponentDataType
}                                                               from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {INFertilizationPlanningGridItem}                        from '../types/ap-n-fertilization-planning-types';
import {
  ApNFertilizationShowComponentData
}                                                               from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-show-configs/ap-n-fertilization-show-types';
import {
  ApNFertilizationPlanningEntryComponent
}                                                               from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-planning-entry.component';
import {OperationModesEnum, OperationModesStore}                from '../../stores/common/operation-modes.store';
import {LicenseStore}                                           from '../../stores/farm/license.store';
import {NdiStore}                                               from '../../stores/ndi/ndi.store';
import {SensorStore}                                            from '../../stores/sensor/sensor.store';

@Component({
  selector: 'ap-n-fertilization-planning',
  template: `
    <ap-dyncomponent [caption]="'Global__Plannings'"
                     [selectable]="{checkboxOnly: false, mode: 'single'}"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [pager]="pager"
                     [columns]="columns"
                     [canSearch]="true"
                     [canCreate]="true"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApNFertilizationPlanningComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent) dynComponent: ApDynComponentComponent;
  columns: ApDynGridColumnConfigBase[] = [];
  items$: Observable<any[]>;
  loading$: Observable<boolean>;
  pager: ApDynGridPagerConfigBase;

  private _subscriptions: Subscription[] = [];

  constructor(private fertilizerStore: FertilizerStore,
              private ndiStore: NdiStore,
              private formStore: FormStore,
              private licenses: LicenseStore,
              private sensorStore: SensorStore,
              private campaignYearStore: CampaignYearStore,
              private operationModesStore: OperationModesStore,
              private cropApplicationStore: CropApplicationStore,
              private cropTypeStore: CropTypeStore,
              private fieldStore: FieldStore,
              private gridBuilder: NFertilizationPlansGridBuilderService,
              private modalDialogPresets: ModalDialogPresets,
              private modalDialogStore: ModalDialogStore,
              private nFertilizationStore: NFertilizationStore,
              private routerStore: RouterStore,
              private mapStore: MapStore,
              private statisticStore: StatisticStore,
              private nCommonService: ApNFertilizationCommonService,
              private tooltipContentService: ApTooltipContentService,
              private nFertilizationService: NFertilizationService,
              private nFertilizationComponentService: ApNFertilizationComponentService,
              private fertilizerService: FertilizerService) {
  }

  public ngOnInit(): void {
    this.loading$ = combineLatest([
      this.nFertilizationStore.Listen(s => s.logfilesLoading),
      this.nFertilizationStore.Listen(s => s.loading),
      this.nFertilizationStore.Listen(s => s.planBooksLoading),
      this.cropApplicationStore.Listen(s => s.loading),
      this.sensorStore.Loading$,
      this.ndiStore.Loading$,
      this.licenses.Loading$,
      this.operationModesStore.Loading$
    ]).pipe(
      map((loadings) => loadings.some((x) => x))
    );
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).subscribe(() => {
      this.nFertilizationStore.LoadNFertilizationPlanningSummaries();
    }));
    this._buildGrid();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe((items) => {
      this._onSelectedItemsChanged(items);
    }));
    this._subscriptions.push(combineLatest([
      this.routerStore.Listen(s => s),
      this.items$,
      this.nFertilizationStore.Listen(s => s.loading)
    ]).pipe(
      filter(([routerStoreData, gridItems, gridItemsLoading]) =>
        routerStoreData.url?.startsWith('/n-fertilization/planning') && routerStoreData.queryParams['id'] !== undefined && gridItems?.length !== 0 && !gridItemsLoading),
      first(),
    ).subscribe(([routerStoreData, gridItems]) => {
      const targetGridItem = gridItems.find(_ => _.Id === routerStoreData.queryParams['id']);
      const targetComponent = routerStoreData.queryParams['action'] === TaskManagementAction.Booking ?
        ApNFertilizationBookingComponent : ApNFertilizationEditComponent;
      setTimeout(() => {
        this.formStore.openForm({
          component: targetComponent,
          data: {dataItem: targetGridItem, book: true}
        });
        if (routerStoreData.queryParams['url']) {
          this._subscriptions.push(this.formStore.FormClose$.subscribe(() => this.routerStore.navigate([routerStoreData.queryParams['url']])));
        }
      }, 0);
    }));
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
      // trigger refresh of selection and map after entryComponent (e.g. 'NEW') closed
      setTimeout(() => this._onSelectedItemsChanged(this.dynComponent?.getSelectedItems()), 1);
    }));
  }

  private _onSelectedItemsChanged(items: any[]): void {
    const fieldIds = items.map((item) => item.FieldIds).flat();
    this.fieldStore.changeSelectedField(fieldIds.filter((v, i, a) => a.indexOf(v) === i));
    const planBooks = items.map((item) => item.PlanBooks.filter((x: any) => !x.DeletedAt && !x.BookedBy)).flat();
    const currentUrl = this.routerStore.Listen(s => s.url).getValue();
    this.nFertilizationComponentService.showPlanBookStatisticOnMap(planBooks, currentUrl);
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
    this.statisticStore.removeStatisticData();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
  }

  public onCreate(): void {
    this.statisticStore.removeStatisticData();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
    if (this.dynComponent.dynGrid.gridPaging.selectedKeys.length !== 0) {
      const selectedItem = (this.dynComponent.dynGrid.gridPaging.items.find(x => x.Id === this.dynComponent.dynGrid.gridPaging.selectedKeys[0]) as INFertilizationPlanningGridItem);
      this.formStore.openForm({
        component: ApNFertilizationPlanningEntryComponent,
        data: {
          Summary: ObjectFactory.Copy(selectedItem?.Summary),
          PlanBooks: ObjectFactory.Copy(selectedItem?.PlanBooks),
          Type: PlanningEntryComponentDataType.Edit
        }
      });
    } else {
      this.formStore.openForm({
        component: ApNFertilizationPlanningEntryComponent,
        data: {
          Summary: undefined,
          Type: PlanningEntryComponentDataType.Create
        }
      });
    }
  }

  private _buildGrid(): void {
    const gridOptions: DropDownButtonData[] = [
      {
        text: 'Global__Show',
        callback: ApUtilService.createEventEmitter(this._show.bind(this), this._subscriptions),
      },
      /* vorrübergehend deaktiviert
      {
        text: 'Global__Edit',
        callback: ApUtilService.createEventEmitter(this._edit.bind(this), this._subscriptions)
      },*/
      {
        text: 'Task_Mgmt_Export',
        callback: ApUtilService.createEventEmitter(this._export.bind(this), this._subscriptions),
      },
      {
        text: 'Global__Booking',
        callback: ApUtilService.createEventEmitter(this._book.bind(this), this._subscriptions),
        disabled: (item) => !this._isBookProcessAvailable(item['OperationModeKey'])
      },
      {
        text: 'Global__Delete',
        callback: ApUtilService.createEventEmitter(this._delete.bind(this), this._subscriptions),
      }
    ];

    this.columns = this.gridBuilder.planningBookingGrid(gridOptions);
    const pagerOptions = [
      {
        text: 'Global__Delete',
        callback: ApUtilService.createEventEmitter(this._deleteMany.bind(this), this._subscriptions)
      },
    ];
    this.pager = PagerBuilder.PlanningBookingPager(pagerOptions);

    this.items$ = combineLatest([
      this.nFertilizationStore.Listen(x => x.planBooks),
      this.cropTypeStore.Listen(s => s.cropTypesNames),
      this.fieldStore.Listen(s => s.data),
      this.cropApplicationStore.Listen(s => s.data),
      this.ndiStore.NdiStatistics$
    ]).pipe(
      filter(([planBooks, cropTypesNames, fields, applications, _]) =>
        !!planBooks && !!cropTypesNames && !!fields && !!applications && applications.length !== 0),
      map(([planBooks, cropTypesNames]) => {
        const summaries = this.nFertilizationComponentService.getSummaryWithPlanBooks(planBooks, false);
        return summaries.filter(x => x.FilteredPlanBooks && x.FilteredPlanBooks.length > 0)
          .map((s: ISummaryWithPlanBooks) => {
            const operationMode = s.Summary?.OperationMode;
            const cropId = this.nFertilizationComponentService.getCropId(s.FilteredPlanBooks);
            const productId = this.nFertilizationComponentService.getProductId(s.FilteredPlanBooks);
            const fertilizer = this.fertilizerStore.getFertilizer(productId);
            const applicationRate = this.nFertilizationComponentService.getApplicationRateFromPlanBooks(s.FilteredPlanBooks);
            const planBookApplicationDates = this.nFertilizationComponentService.getApplicationDatesData(s.FilteredPlanBooks);
            return {
              Id: s.Summary?.Id,
              Summary: s.Summary,
              Status: this.nFertilizationComponentService.getStatus(s),
              FieldIds: s.FilteredPlanBooks.map((pb) => pb.FieldId),
              Crop: cropTypesNames[cropId ?? ''],
              CropId: cropId,
              Appl: this.nFertilizationService.getApplicationRateNameByApplication(applicationRate),
              ApplSum: this.nCommonService.getApplSum(s.FilteredPlanBooks),
              ApplSumTooltip: this.nCommonService.getApplSum(s.FilteredPlanBooks),
              Count: this.nFertilizationComponentService.getPlanBooksFieldsCount(s.TotalPlanBooks, false),
              Area: this.nFertilizationComponentService.getArea(s.FilteredPlanBooks),
              OperationMode: this.nCommonService.getOperationMode(operationMode),
              OperationModeKey: operationMode?.Key ?? '',
              Product: this.fertilizerService.getFertilizerProductName(fertilizer),
              ProductId: productId,
              ProductUnit: this.nCommonService.getProductUnit(s.FilteredPlanBooks.FirstOrDefault()),
              ProductTooltip: this.tooltipContentService.getProductContentInfoTooltip(productId),
              Avg: s.Summary?.UserApplicationRate,
              Min: s.Summary?.UserApplicationMinimum,
              Max: s.Summary?.UserApplicationMaximum,
              ApplicationDate: planBookApplicationDates.NewestDate,
              ApplicationDateTooltip: planBookApplicationDates.Tooltip,
              ApplicationDateItalic: planBookApplicationDates.IsMoreThanOneUniqDate,
              Note: s.Summary?.Title,
              PlanBooks: s.FilteredPlanBooks,
              PlanNumber: s.Summary?.PlanNumber,
              FieldsTooltip: this.tooltipContentService.getFieldsCropsTooltip(s.FilteredPlanBooks)
            } as INFertilizationPlanningGridItem;
          });
      })
    );
  }

  private _isBookProcessAvailable(operationModeKey: string | undefined): boolean {
    const operationMode = operationModeKey as OperationModesEnum;
    if (!operationMode) {
      return false;
    }
    const operationModesAvailableForBookProcess = [
      OperationModesEnum.Constant,
      OperationModesEnum.ApplicationMap,
      OperationModesEnum.ApplicationMapAbsolute,
      OperationModesEnum.NfTargetMapPerPlan
    ];
    return operationModesAvailableForBookProcess.includes(operationMode);
  }

  private _book(dataItem: INFertilizationPlanningGridItem): void {
    this.formStore.openForm({component: ApNFertilizationBookingComponent, data: {dataItem, book: true}});
  }

  private _export(dataItem: INFertilizationPlanningGridItem): void {
    this.routerStore.navigate(['task-management/overview'], {
      id: dataItem.Summary.Id,
      url: 'n-fertilization/planning'
    }).then();
  }

  private _show(dataItem: INFertilizationPlanningGridItem): void {
    const planBooksIds = dataItem.PlanBooks.map(x => x.Id);
    if (!planBooksIds) {
      return;
    }

    const currentUrl = this.routerStore.Listen(s => s.url).getValue();
    this.nFertilizationComponentService.showPlanBookStatisticOnMap(dataItem.PlanBooks, currentUrl);

    const componentData: ApNFertilizationShowComponentData = {
      PlanBookIds: planBooksIds,
      IsBooked: false
    };
    this.formStore.openForm({component: ApNFertilizationShowComponent, data: componentData});
  }

  private _delete(dataItem: INFertilizationPlanningGridItem): void {
    this.modalDialogStore.setModalDialogData(this.modalDialogPresets.DeleteDialog());
    const modalDialogSubscription = this.modalDialogStore.Listen(s => s.result)
      .pipe(skip(1))
      .subscribe((result) => {
        modalDialogSubscription.unsubscribe();
        if (result.key === 'delete') {
          this.nFertilizationStore.DeleteNFertilizationSummaries([dataItem.Summary]);
        }
      });
  }

  private _deleteMany(): any {
    this.nFertilizationStore.DeleteNFertilizationSummaries(
      this.dynComponent.getSelectedItems().map((item: INFertilizationPlanningGridItem) => item.Summary)
    );
  }

  /* removed for now
  private _edit(dataItem: any): void {
    this.formStore.openForm({component: ApNFertilizationEditComponent, data: {dataItem}});
  }*/
}
